export const BUSINESS_ACTIVITY_SECTION_ID = 'business-activity-section';
export const BUSINESS_ACTIVITY_SECTION_TITLE = 'Business Activity Section';
